import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  companiesFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["createdAt,DESC"]
  },
  currentCompanyParentId: null
};

type State = typeof initialState;

export enum actionTypes {
  SET_COMPANIES_FILTERS = "setCompaniesFilters",
  RESET_COMPANIES_FILTERS = "resetCompaniesFilters",
  SET_CURRENT_COMPANY_PARENT_ID = "setCurrentCompanyParentId"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_COMPANIES_FILTERS: {
      return {
        ...state,
        companiesFilters: action.payload
      };
    }
    case actionTypes.RESET_COMPANIES_FILTERS: {
      return {
        ...state,
        companiesFilters: initialState.companiesFilters
      };
    }
    case actionTypes.SET_CURRENT_COMPANY_PARENT_ID: {
      return {
        ...state,
        currentCompanyParentId: action.payload
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.companies, dispatch];
};

export default reducer;
